export default class CurrencyExchangeController {
    constructor(
        currencyExchangeClient,
        currencyExchangeManager,
        $filter,
        PROVIDERS,
        toastDispatcher,
        translator,
        $routeParams,
        $route,
        country
    ) {
        this.$route = $route;
        this.$routeParams = $routeParams;
        this.$filter = $filter;
        this.PROVIDERS = PROVIDERS;
        this.toastDispatcher = toastDispatcher;
        this.translator = translator;
        this.currencyExchangeClient = currencyExchangeClient;
        this.currencyExchangeManager = currencyExchangeManager;
        this.rates = {};
        this.loading = false;
        this.loadRatesPromise = null;

        this.filter = {};
        this.currencies = angular.copy(this.availableCurrencies.supportedCurrencies);
        this.currencies.unshift(translator.trans("currency_exchange.all_currencies"));

        this.parameters = {
            locale: 'lt',
            clientType: 'natural',
            from_currency: $routeParams.from_currency ? $routeParams.from_currency : null,
            to_currency: $routeParams.to_currency ? $routeParams.to_currency : null,
            from_amount: this.getFromAmount(),
            to_amount: $routeParams.to_amount ? $routeParams.to_amount : null,
            providers: this.supportedProviders,
            country_code: $routeParams.country_code ? $routeParams.country_code : country.getCurrentCountry().toLowerCase()
        };

        this.loadRatesData(this.parameters);
    }

    getCurrencyTranslation(currencyCode) {
        for (var i = 0; i < this.currencyTranslations.length; i++) {
            if (this.currencyTranslations[i].code === currencyCode) {
                return this.currencyTranslations[i].name;
            }
        }
    }

    getFromAmount() {
        if (this.$routeParams.from_amount) {
            return this.$routeParams.from_amount;
        } else if (this.$routeParams.to_amount) {
            return null;
        } else {
            return "100";
        }
    }


    loadRatesData(parameters) {
        var currenciesArray = angular.copy(this.availableCurrencies.supportedCurrencies);

        if (!parameters.from_currency) {
            parameters.from_currency = parameters.to_currency && !angular.isArray(parameters.to_currency)
                ? currenciesArray
                : this.availableCurrencies.defaultCountryCurrency;
        }

        if (!parameters.to_currency) {
            parameters.to_currency = currenciesArray;
        }

        this.loading = true;

        this.loadRatesPromise = this.currencyExchangeManager.loadRates(
            parameters,
            this.supportedProviders
        );

        this.loadRatesPromise.then(
            (response) => {
                this.rates = angular.extend({}, this.rates, response.rates);

                this.filter.from = this.parameters.from_currency && !angular.isArray(this.parameters.from_currency)
                    ? this.parameters.from_currency
                    : this.translator.trans("currency_exchange.all_currencies");

                this.filter.from_amount = this.parameters.from_amount;

                this.filter.to = angular.isArray(this.parameters.to_currency)
                    ? this.translator.trans("currency_exchange.all_currencies")
                    : this.parameters.to_currency;

                this.filter.to_amount = this.parameters.to_amount;
            },
            (response) => {
                var error = response.data
                    ? this.translator.trans("currency_exchange." + response.data.error)
                    : this.translator.trans("currency_exchange.unknown_error");

                //If request was not cancelled
                if (response.status !== -1) {
                    this.toastDispatcher.error(error);
                }

                this.rates = {};
            }
        ).finally(() => {
            this.loading = false;
        });
    }

    getCommercialRateDifference(provider, currency_to) {
        var amountField = this.getAmountField();
        var signModifier = this.parameters.from_amount ? 1 : -1;

        return this.rates.commercial && this.rates.commercial[currency_to]
            ? this.$filter('number')(
            (this.rates[provider][currency_to][amountField] - this.rates.commercial[currency_to][amountField]) * signModifier,
            2
        )
            : 0;
    }

    filterExchangeRates() {
        var newParameters = angular.copy(this.parameters);
        newParameters.from_currency = this.filter.from != this.translator.trans("currency_exchange.all_currencies")
            ? this.filter.from
            : null;
        newParameters.to_currency = this.filter.to != this.translator.trans("currency_exchange.all_currencies")
            ? this.filter.to
            : null;
        newParameters.from_amount = this.filter.from_amount;
        newParameters.to_amount = this.filter.to_amount;

        if (this.loadRatesPromise.$$state.pending) {
            this.loadRatesPromise.cancel();
        }

        this.$route.updateParams(newParameters);
    }

    clearFilter() {
        this.filter.from = this.availableCurrencies.defaultCountryCurrency;
        this.filter.to = null;
        this.filter.from_amount = 100;
        this.filter.to_amount = null;

        this.filterExchangeRates();
    }

    showRate(currency) {
        return  (
                    (currency !== this.parameters.from_currency)
                    && (currency !== this.parameters.to_currency)
                    && (
                        angular.isArray(this.parameters.to_currency)
                        || angular.isArray(this.parameters.from_currency)
                    )
                ) || (
                    !angular.isArray(this.parameters.to_currency)
                    && !angular.isArray(this.parameters.from_currency)
                    && currency === this.parameters.to_currency
                );
    }

    getAmountField() {
        return this.parameters.from_amount ? 'to_amount' : 'from_amount';
    }

    getCurrencyField(currency_to) {
        var currencyField = (
            (this.parameters.to_amount && !angular.isArray(this.parameters.to_currency))
            || angular.isArray(this.parameters.from_currency)
        )
        ? 'from_currency'
        : 'to_currency';

        if (typeof this.rates[this.PROVIDERS.OFFICIAL][currency_to] !== 'undefined') {
            return this.rates[this.PROVIDERS.OFFICIAL][currency_to][currencyField];
        }

        return this.rates[this.PROVIDERS.COMMERCIAL][currency_to][currencyField];
    }

    onCurrencyChange(currencyField) {
        if (
            this.filter.from === this.translator.trans("currency_exchange.all_currencies")
            && this.filter.to === this.translator.trans("currency_exchange.all_currencies")
        ) {
            this.filter[currencyField === 'from' ? 'to' : 'from'] = this.availableCurrencies.defaultCountryCurrency;
        }
    }

    isToCurrencyVisible() {
        return angular.isArray(this.parameters.from_currency) && this.parameters.from_amount;
    }
}

CurrencyExchangeController.$inject = [
    'currencyExchangeClient',
    'currencyExchangeManager',
    '$filter',
    'PROVIDERS',
    'toastDispatcher',
    'translator',
    '$routeParams',
    '$route',
    'country'
];
